import React from 'react'
import {
  BlockIcon,
  BuddyIcon,
  ShieldIcon,
  TakhayerFeature,
  TasksIcon,
  TickIcon,
} from '../../components/SVGIcons'

const flexibleIconList = [
  {
    icon: <TickIcon />,
    description: 'flexible-icon-list tick',
  },
  {
    icon: <TasksIcon />,
    description: 'cars-who-can',
  },
  {
    icon: <BuddyIcon />,
    description: 'flexible-icon-list buddy',
  },
  {
    icon: <BlockIcon />,
    description: 'flexible-icon-list block 1',
  },
  {
    icon: <BlockIcon />,
    description: 'flexible-icon-list block 2',
  },
]

export const productFeaturesData = {
  'auto-leasing': [
    {
      type: 'SEVENTY',
      subType: 'svg',
      title: 'flexible',
      subtitle: null,
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: null,
      iconList: flexibleIconList,
      richText: null,
    },
    {
      type: 'THIRTY',
      subType: 'svg',
      title: 'auto-leasing-THIRTY-1-title',
      subtitle: 'default-auto-leasing-30-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <ShieldIcon />,
      richText: null,
    },
    {
      type: 'SIXTY-FULL',
      subType: 'cta',
      title: 'after-sales-banner-full-main-text',
      titleSuffix: 'after-sales-banner-full-main-text-sffix',
      subtitle: 'after-sales-banner-full-sub-text',
      imageShouldSwitchLocale: false,
      imageUrl: {
        desktop: '/after-sales-banner.png',
        mobile: '/after-sales-banner.png',
      },
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: '/auto-leasing/after-sales-services',
      icon: null,
      richText: null,
    },
    // {
    //   type: 'FORTY',
    //   subType: 'icon',
    //   title: 'takhayer-FORTY-2-title',
    //   subtitle: null,
    //   imageUrl:
    //     '/assets/desktop/Leasing/03-1%20Leasing%20Feature%20Used%20New.jpg',
    //   fancyTitle: null,
    //   ctaTitle: null,
    //   ctaHref: null,
    //   icon: null,
    //   richText: null,
    // },
    // {
    //   type: 'SIXTY',
    //   subType: 'cta',
    //   title: 'takhayer-SIXTY-2-title',
    //   subtitle: null,
    //   imageShouldSwitchLocale: true,
    //   imageUrl: {
    //     desktop:
    //       '/assets/SVG Assets/SVG - Plain/02-06 After Sales Feature Mobile.svg',
    //     mobile:
    //       '/assets/SVG Assets/SVG - With Image/03-02 After Sales Feature Mobile.svg',
    //   },
    //   fancyTitle: null,
    //   ctaTitle: null,
    //   ctaHref: '/auto-leasing/after-sales-services',
    //   icon: null,
    //   richText: null,
    // },
    {
      type: 'HUNDRED',
      subType: 'icon',
      title: 'auto-leasing-HUNDRED-1-title',
      subtitle: 'auto-leasing-HUNDRED-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <TakhayerFeature />,
      backgroundColor: 'normal',
      richText: null,
    },
  ],
}
